import bobtailAPI from '../axiosConfig'
import Entity from './entity'

const ClientDebtorAssignment = new Entity('clientdebtorassignments')

ClientDebtorAssignment.createAssignment = async (params) => {
  return (await bobtailAPI()).post(`${ClientDebtorAssignment.baseUrl}/create-assignment`, {
    ...params,
  })
}

ClientDebtorAssignment.getNOAEmails = async (params) => {
  return (await bobtailAPI()).get(`${ClientDebtorAssignment.baseUrl}/noa-emails/${params.id}`, {
    params,
  })
}

ClientDebtorAssignment.resendNOA = async (params) => {
  return (await bobtailAPI()).post(`${ClientDebtorAssignment.baseUrl}/resend-noa`, {
    ...params,
  })
}

ClientDebtorAssignment.sendAssignmentEmail = async (params) => {
  return (await bobtailAPI()).post(`${ClientDebtorAssignment.baseUrl}/send-release-letter/${params.id}`, {
    ...params,
  })
}

ClientDebtorAssignment.getClientDebtorAssignment = async (params) => {
  return (await bobtailAPI()).get(`${ClientDebtorAssignment.baseUrl}/get-client-debtor-assignment/${params.client_id}/${params.debtor_id}`, {
    ...params,
  })
}

export default ClientDebtorAssignment
